import {
    Component, ComponentFactoryResolver, EventEmitter, Input, OnChanges, OnInit, Output,
    ViewChild
} from '@angular/core';
import {SteelProfileFormDirective} from '../steel-profile-form.directive';
import {SteelProfile} from '../../steel-profile';
import {SteelProfileService} from '../../steel-profile.service';
import {SpecificSteelProfileForm} from '../specific-steel-profile-form';


@Component({
    selector: 'app-steel-profile-form-selector',
    templateUrl: './steel-profile-form-selector.component.html',
    styleUrls: ['../../../project/project-form-components/project-form.css']
})
export class SteelProfileFormSelectorComponent implements OnInit, OnChanges {
    @ViewChild(SteelProfileFormDirective)
    private steelProfileForm: SteelProfileFormDirective;
    @Input() profile: SteelProfile;
    @Output() specificIsValid = new EventEmitter<boolean>();
    @Input() profileTypes;
    // subscription: any;

    constructor(private componentFactoryResolver: ComponentFactoryResolver, private steelProfileService: SteelProfileService) {
    }

    ngOnInit() {
        this.loadForm();
    }

    ngOnChanges() {
        this.loadForm();
    }

    loadForm() {
      var family = "";
      for(var i = 0; i < this.profileTypes.length; i++){
        if(this.profileTypes[i].value == this.profile.profile_type){
          family = this.profileTypes[i].family;
          break;
        }
      }

      var formComponent = SteelProfile.getSteelProfileFormComponent(family);
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
            (SteelProfile.getSteelProfileFormComponent(family)) );

        const viewContainerRef = this.steelProfileForm.viewContainerRef;
        viewContainerRef.clear();

        const componentRef = viewContainerRef.createComponent(componentFactory);
        (<SpecificSteelProfileForm>componentRef.instance).profile = this.profile;
        (<SpecificSteelProfileForm>componentRef.instance).specificIsValid.subscribe((event) => {
            this.specificIsValid.emit(event);
        });

    }
}



// WEBPACK FOOTER //
// ./src/app/steel-profile/steel-profile-forms/steel-profile-form-selector/steel-profile-form-selector.component.ts